import { FormattedMessage } from 'react-intl';
import { useState, JSX } from 'react';

import { useStyles } from './signatories-section.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { SectionTitle } from '../../../common/section-title';
import { Button } from '../../../common/button';
import { SectionLabels } from '../../../../constants/common-constants';
import { getName } from './utils/get-name';

export const SignatoriesSection = (): JSX.Element => {
  const DISPLAY_NUMBER = 18;
  const [isShown, setIsShown] = useState(false);
  const importLogos = (response: any): string[] => response?.keys()?.map(response);
  const logos = importLogos((require as any)?.context('../../../../assets/images/signatories', false, /logo-\d+\.svg$/)) as string[];
  const [displayLogos, setDisplayLogos] = useState(logos?.slice(0, DISPLAY_NUMBER));
  const classes = useStyles();
  const id = SectionLabels.signatories;
  const isManyLogos = false;

  const handleShowMore = (): void => {
    setDisplayLogos(isShown ? logos?.slice(0, DISPLAY_NUMBER) : logos);
    setIsShown(!isShown);
  };

  const handleSearch = (value: string): void => {
    setDisplayLogos(logos?.filter(item => getName(item)?.includes(value)));
  };

  return (
    <section
      className={classes.root}
      data-testid="principles"
      aria-labelledby={id}
    >
      <ContentWrapper externalStyles={classes.contentStyles}>
        <SectionTitle
          id={id}
          colorPart="signatories.title-1"
          title="signatories.title-2"
          content="signatories.content"
          isTitleLineBreak
        />
        <div className={classes.logosWrapper}>
          {isManyLogos && (
            <div className={classes.search}>
              <label htmlFor="search-field" className={classes.searchLabel}><FormattedMessage id="search.label" /></label>
              <input
                className={classes.input}
                type="text"
                id="search-field"
                onChange={(event) => handleSearch(event.target.value)}
              />
            </div>
          )}
          <ul className={classes.list}>
            {displayLogos.map((item, index) => (
              <li key={index} className={classes.listItem}>
                <img height={48} width={171} src={item} alt="" />
              </li>
            ))}
          </ul>
        </div>
        {isManyLogos && (
          <div className={classes.ctaWrapper}>
            <Button
              variant="light"
              ariaLabel="signatories.showMore.ariaLabel"
              onClick={handleShowMore}
            >
              <FormattedMessage id={isShown ? 'showLess' : 'showMore'} />
            </Button>
          </div>
        )}
      </ContentWrapper>
    </section>
  );
};
